export const DID_FINISH_LOAD = 'didFinishLoad';
export const OPEN_EXTERNAL_LINK = 'openExternalLink';
